import {
    isValidMachineSubType,
    isValidMachineType,
    MachineSubType,
    MachineType,
} from '@internal/utils/machine/MachineType';

export const getCleanMachineType = (
    machineType: unknown,
): MachineType | null =>
    !!machineType && isValidMachineType(machineType) ? machineType : null;

export const getCleanMachineSubType = (
    machineSubType: unknown,
    machineType: MachineType,
): MachineSubType | null => {
    const upperCaseSubType = String(machineSubType).toUpperCase();
    return upperCaseSubType &&
        isValidMachineSubType(upperCaseSubType, machineType)
        ? upperCaseSubType
        : null;
};
